import React, { createContext, useContext, useState, ReactNode } from 'react';
import MToast, { MToastProps } from './MToast';

type ToastContextType = {
  showToast: (props: MToastProps) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within an MToastProvider');
  return ctx;
};

export const MToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<Array<{ id: number; props: MToastProps }>>([]);

  const showToast = (props: MToastProps) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, props }]);
    if (props.duration && props.duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, props.duration);
    }
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Single toast container that respects the position prop */}
      <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {toasts.map(({ id, props }) => (
          <MToast 
            key={id} 
            {...props} 
            position={props.position || 'top'} // Default to top
            onClose={() => setToasts((prev) => prev.filter((t) => t.id !== id))} 
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
